import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ListBoxComponent } from '@syncfusion/ej2-angular-dropdowns';
import { Query } from '@syncfusion/ej2-data';
import { BehaviorSubject } from 'rxjs';

import { Pipe, PipeTransform } from '@angular/core';
import { FormControl } from '@angular/forms';

@Pipe({
  name: 'getValueFromOption'
})

export class GetValueFromOptionPipe implements PipeTransform {
  transform(value: any, options: { label: string; value: any }[]): any {

    const element = Array.isArray(value) && value.length > 0 ? value[0] : value;
    const label = options.find((p) => p.value === element)?.label;
    if (label) {
      return label;
    }

    return null

  }
}
@Component({
  selector: 'formly-field-select-with-filter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `

 <!-- <ejs-dropdownlist
      [class.ng-dirty]="showError"
      [placeholder]="to.placeholder"
      [formControl]="$any(formControl)"
      [fields]="fields"
      [dataSource]="to.options | formlySelectOptions: field | async"
      (change)="to.change && to.change(field, $event)"
      [showClearButton]="true"
      (open)="open($event)"
    >
    <ng-template #itemTemplate let-data>
      <div class="white-space-wrap">
        {{data.label}}
      </div>
    </ng-template>
  </ejs-dropdownlist> -->

  <div class="e-control e-dropdownlist e-lib ng-star-inserted ng-valid ng-touched" tabindex="-1" (click)="open($event)"  
  [ngClass]="{'e-disabled': formControl.disabled}"
  >
    <div class="e-input-group e-control-wrapper e-ddl flex justify-between e-lib e-keyboard e-valid-input"
    [ngClass]="{'e-disabled': formControl.disabled}" tabindex="0" (focus)="open($event)" style="width: 100%;">
    
      <span tabindex="-1" class="e-input block text-wrap flex-grow p-2 leading-4">
        <ng-container
          *ngIf="
            (formControl.value | getValueFromOption : (to.options | formlySelectOptions: field | async)); else placeholderTemplate;
        ">
          {{ formControl.value | getValueFromOption : (to.options | formlySelectOptions: field | async) }}
        </ng-container>
        <ng-template #placeholderTemplate>
          {{ to.placeholder}}
        </ng-template>
      </span>

      <div>
        <span *ngIf="formControl.value" class="e-clear-icon e-clear-icon-hide" aria-label="close" role="button" (click)="formControl.setValue(null)"></span>
        <span class="e-input-group-icon e-ddl-icon e-search-icon"></span>
      </div>
    </div>
  </div>

  <ejs-dialog (overlayClick)="close()" *ngIf="openDialog | async" [closeOnEscape]="false" [isModal]="true" [visible]="true" width="800px">
    <ng-template #content>
      <div class="flex flex-col h-[80vh]">
        <div class="flex-none">
          <h2 class="h2--big"> {{to.label}} </h2>
        </div>

        <div class="flex-none pb-4">
          <input (input)="onFilterChange($event)" [placeholder]="'TPA.Search' | transloco"   class="e-input"
          [type]="to.type || 'text'" />
        </div>

        <div class="flex-grow min-h-0 overflow-auto">
          <ejs-listbox
              [formControl]="$any(tempFormControl)"
              [fields]="fields"
              [dataSource]="to.options | formlySelectOptions: field | async"
              [selectionSettings]="selection"
              (keydown)="submit($event)"
              [sortOrder]='sorting'
              >
            </ejs-listbox>
        </div>
      </div>
    </ng-template>
    <ng-template #footerTemplate>
      <button (click)="close()" class="e-btn e-lib e-secondary" type="button"> {{ 'TPA.Cancel' | transloco | firstToUpperCase }}</button>
      <button (click)="closeWithConfirm()" class="e-btn e-lib e-primary"> {{ 'TPA.Confirm' | transloco | firstToUpperCase }}</button>
    </ng-template>
  </ejs-dialog>


  `,
  styles: [
    `

    ::ng-deep .e-lib.e-listbox-wrapper:not(.e-list-template) .e-list-item,
    ::ng-deep .e-lib.e-listbox-wrapper .e-selectall-parent {
        min-height: 40px;
        height: auto;
    }


    `
  ]
})
export class SelectWithDialogFormlyField extends FieldType {
  public fields = { text: 'label', value: 'value' };
  public openDialog = new BehaviorSubject<boolean>(false);
  public tempFormControl = new FormControl(null);
  @ViewChild(ListBoxComponent) cmp: ListBoxComponent;




  public selection = { mode: "Single" }

  defaultOptions = {
    props: {
      options: [],
      allowFiltering: false,

    }
  };

  public sorting = 'Ascending';



  public onFilterChange(e: Event) {

    console.log((e.target as HTMLInputElement).value);

    this.cmp.filter(this.to.options as { text: string, value: string }[], new Query().where('label', 'contains', (e.target as HTMLInputElement).value, true, true));
  }

  public open($event) {

    $event.preventDefault();
    $event.stopPropagation();
    if (!this.formControl.disabled) {
      this.tempFormControl.setValue([this.formControl.value]);
      this.openDialog.next(true);
    }
  }

  public close() {
    this.openDialog.next(false);
  }
  public closeWithConfirm() {
    this.formControl.setValue(this.tempFormControl.value ? this.tempFormControl.value[0] : null);
    this.openDialog.next(false);
  }

  submit(key: any) {
    if (key.keyCode == 13) {
      this.closeWithConfirm()
    }

  }





}
